import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export default function Delete(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon viewBox={'0 0 13.642 14.845'} fontSize={'inherit'} {...props}>
      <path
        id="Tracé_124"
        data-name="Tracé 124"
        d="M2.466,14.845a1.455,1.455,0,0,1-1.053-.454,1.438,1.438,0,0,1-.459-1.053V2.231H.74A.705.705,0,0,1,.216,2.01.74.74,0,0,1,0,1.473.724.724,0,0,1,.216.94.711.711,0,0,1,.74.724h3.4A.679.679,0,0,1,4.359.2a.749.749,0,0,1,.53-.2H8.734a.759.759,0,0,1,.532.2.674.674,0,0,1,.222.521h3.391a.738.738,0,0,1,.542.221.723.723,0,0,1,.222.533.721.721,0,0,1-.222.536.744.744,0,0,1-.541.218h-.215V13.338a1.555,1.555,0,0,1-1.512,1.507Zm0-1.507h8.686V2.231H2.466Zm1.939-2.357a.673.673,0,0,0,.209.493.682.682,0,0,0,.5.209.708.708,0,0,0,.5-.209.66.66,0,0,0,.218-.493V4.573a.7.7,0,0,0-.218-.51A.7.7,0,0,0,5.1,3.847a.654.654,0,0,0-.492.216.715.715,0,0,0-.206.51Zm3.4,0a.669.669,0,0,0,.212.493.69.69,0,0,0,.5.209.708.708,0,0,0,.5-.209.66.66,0,0,0,.218-.493V4.573a.739.739,0,0,0-.729-.726.664.664,0,0,0-.5.216.711.711,0,0,0-.208.51ZM2.466,2.231v0Z"
        transform="translate(0 0)"
        fill="#333"
      />
    </SvgIcon>
  );
}
